import React from 'react'
import ProtectionSuccess from '../protection-success'

const ProtectionSuccessDe = () => {
    return <ProtectionSuccess languageCode="de" />
}

export default ProtectionSuccessDe
